import {DatePicker, Select} from 'antd';
import React, {useRef, useState, useMemo} from 'react';
import './style.css';
import DateSvg from '../../../Assets/svgComponents/DateSvg';
import filter_by from '../../../Assets/filter-by.svg';
import DateDesortSvg from '../../../Assets/svgComponents/DateDesortSvg';
import {
  generateYearOptions,
  isNullUndefinedEmpty,
} from '../../../Util/commonUtility';
import useLocalization from '../../../Localization';
const {RangePicker} = DatePicker;

const CommonTitleWithFilters = ({
  title,
  handleChapterFilter,
  handleEventTypeFilter,
  newChaptersList,
  eventTypeList,
  eventTypeSelect = false,
  chapterSelect = false,
  dateSelect = false,
  yearSelect = false,
  usedForChapPage = false,
  usedForPastEvents = false,
  handleYearFilter,
  dateToggle,
  dateOrderHandler,
  selectedChapterValue,
  selectedEventTypeValue,
  selectedDateValue,
  selectedYearValue,
  isShowFilter,
}) => {
  const {ApplicationString} = useLocalization();
  const selectRef = useRef(null);
  const yearOptions = generateYearOptions(ApplicationString);
  const handleFocus = () => {
    selectRef.current && selectRef.current.blur();
  };
  const clearFilter = {value: '', label: ApplicationString['eventListing.clearFilter']}

  const chapterOptions = newChaptersList?.length > 0 ? [clearFilter , ...newChaptersList] : []
  const eventTypeOptions = eventTypeList?.length > 0 ? [clearFilter , ...eventTypeList] : []

  return (
    <div
      className={`upcoming-events-heading-container ${
        usedForPastEvents && 'usedForPast'
      } ${
        usedForPastEvents &&
        'upcoming-events-heading-container-responsive-for-past-events'
      } ${
        usedForChapPage &&
        'upcoming-events-heading-container-responsive-for-chapter-page'
      }`}>
      <span className='upcoming-title'>{title} </span>
      {isShowFilter && (
        <div
          className={`upcoming-events-heading-button-container ${
            usedForPastEvents &&
            'upcoming-events-heading-button-container-past-events'
          } ${
            usedForChapPage &&
            'upcoming-events-heading-button-container-chapter-page'
          } `}>
          <div className='filter-by-label'>
            <img src={filter_by} alt='filter-by-svg' />
            <span>{ApplicationString['eventListing.filterBy']}</span>
          </div>
          {eventTypeSelect && (
            <Select
              id='event-type-select-1'
              showSearch
              prefixCls='event_type_select'
              defaultValue='Event Type'
              style={{width: '120px'}}
              onSelect={handleFocus}
              onChange={handleEventTypeFilter}
              value={
                isNullUndefinedEmpty(selectedEventTypeValue)
                  ? selectedEventTypeValue
                  : ApplicationString['eventListing.eventType']
              }
              optionFilterProp='children'
              filterOption={(input, option) =>
                String(option?.label ?? '')
                  .toLowerCase()
                  .includes(String(input ?? '').toLowerCase())
              }
              placeholder={
                ApplicationString['eventListing.selectDefaultChapter']
              }
              options={eventTypeOptions}
              ref={selectRef}></Select>
          )}
          {chapterSelect && (
            <Select
              id='chapters-type-select-2'
              showSearch
              prefixCls='event_type_select_chapter'
              defaultValue={ApplicationString['eventListing.chapter']}
              style={{width: '120px'}}
              onSelect={handleFocus}
              onChange={handleChapterFilter}
              value={
                selectedChapterValue ||
                ApplicationString['eventListing.chapter']
              }
              // optionFilterProp='children'
              filterOption={(input, option) =>
                String(option?.label ?? '')
                  .toLowerCase()
                  .includes(String(input ?? '').toLowerCase())
              }
              placeholder={
                ApplicationString['eventListing.selectDefaultChapter']
              }
              options={chapterOptions}
              ref={selectRef}></Select>
          )}
          {dateSelect && (
            // <RangePicker
            //   prefixCls='date_picker'
            //   placeholder='Date'
            //   style={{width: '120px'}}
            //   onChange={filterBydate}
            //   suffixIcon={<DateSvg />}
            // />
            <button
              id='home-datepicker-type-button'
              className={`date_picker event-date-filter-button ${
                usedForChapPage && 'date_picker-chapter-page'
              }`}
              onClick={dateOrderHandler}>
              <span>{ApplicationString['eventListing.date']}</span>
              {!dateToggle ? <DateSvg /> : <DateDesortSvg />}
            </button>
          )}
          {yearSelect && (
            <Select
              id='home-type-year-select'
              className='event-type-select-year'
              showSearch
              prefixCls='event_type_select_year'
              defaultValue='Year'
              style={{width: '120px'}}
              onSelect={handleFocus}
              onChange={handleYearFilter}
              value={
                selectedYearValue || ApplicationString['eventListing.year']
              }
              placeholder={'Select year to filter by'}
              options={yearOptions}
              ref={selectRef}></Select>
          )}
        </div>
      )}
    </div>
  );
};

export default CommonTitleWithFilters;
